module.exports = __webpack_public_path__ + "static/img/1_7_2.1215b98d.jpg";